import { Typography } from '@/ui';

import Choice from './Choice';
import Text from './Text';

import type { SummarySlide, SurveyAggregated, SurveyResult } from '@/types';
import type { FC } from 'react';

interface SlidesProps {
  page: number;
  results: SurveyResult[];
  slides: SummarySlide[];
  aggregated?: SurveyAggregated;
}

const Slides: FC<SlidesProps> = ({ page, results, slides, aggregated }) => {
  const { name, subtext, options, text = '' } = slides[page] ?? {};
  return (
    <>
      <Typography color="text.primary" variant="h6">
        {name}
      </Typography>
      <Typography className="mb-16" color="text.secondary" variant="body2">
        {subtext}
      </Typography>
      {options?.length ? (
        <Choice
          aggregated={(() => {
            if (!aggregated || aggregated.totalResponses <= 0) {
              return undefined;
            }
            if (name === 'Strengths') {
              // Convert array structure to flat object for backward compatibility
              const counts =
                aggregated.strengthsChoices?.reduce(
                  (acc, choice) => ({
                    ...acc,
                    [choice.name]: choice.count,
                  }),
                  {} as Record<string, number>,
                ) ?? {};
              return {
                counts,
                totalResponses: aggregated.totalResponses,
              };
            }
            if (name === 'Growth Opportunities') {
              // Convert array structure to flat object for backward compatibility
              const counts =
                aggregated.growthChoices?.reduce(
                  (acc, choice) => ({
                    ...acc,
                    [choice.name]: choice.count,
                  }),
                  {} as Record<string, number>,
                ) ?? {};
              return {
                counts,
                totalResponses: aggregated.totalResponses,
              };
            }
            return undefined;
          })()}
          question={slides[page] as SummarySlide}
          results={results}
        />
      ) : (
        <Text text={text} />
      )}
    </>
  );
};

export default Slides;
